<template>
  <div class="modal" :class="{ 'is-active': exibirModal }">
    <div class="modal-background" @click="fecharModal"></div>
    <div class="modal-content">
      <div class="box text-center my-2">
        <p>Motivo da Manutenção</p>
        <input
          type="text"
          class="form-control"
          v-model="motivo"
          placeholder="Digite o motivo aqui"
        />
      </div>
      <div class="botoes">
        <button class="btn btn-danger ponteiro mx-2" @click="fecharModal">
          Cancelar
        </button>
        <button class="btn btn-success ponteiro mx-2" @click="confirmar">
          Confirmar
        </button>
      </div>
    </div>
    <button
      class="modal-close is-large ponteiro"
      aria-label="close"
      @click="fecharModal"
    >
      X
    </button>
  </div>
</template>

<script>
export default {
  name: "ModalESConfirmar",
  components: {},
  props: {
    texto: {
      type: String,
      default: "",
    },
    valor: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    fecharModal() {
      this.$emit("fechar");
    },
    confirmar() {
      if (!this.motivo || this.motivo.trim() === "") {
        this.$snackE(`Por favor, digite o motivo da manutenção.`);
        return;
      }
      this.$emit("confirmar", this.motivo);
    },
  },
  watch: {
    valor(val) {
      this.exibirModal = val;
    },
  },
  data() {
    return {
      exibirModal: false,
      motivo: null,
    };
  },
  mounted() {
    console.log("chegou aqui >>>>>>>>>>");
    this.exibirModal = this.valor;
  },
};
</script>

<style scoped>
.modal {
  display: none;
  position: fixed;
  z-index: 20;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal.is-active {
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.modal-content {
  width: fit-content;
  max-width: 80%;
  max-height: 80%;
  background-color: #fff;
  border-radius: 5px;
  padding: 1.5rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
}

.modal-close {
  position: absolute;
  top: 1.5rem;
  right: 1.5rem;
  color: rgb(200, 200, 200);
  background-color: transparent;
  border: none;
  font-size: 1.5rem;
}

.modal-close:hover {
  color: white;
}

@media (max-width: 768px) {
  .modal-content {
    width: 90%;
  }
}

.botoes {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
</style>
